var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-center mb-2"
        },
        [
          _c(
            "gg-btn",
            {
              staticClass: "kvm-dk-text ml-n2",
              attrs: {
                small: "",
                text: ""
              },
              on: {
                click: function click($event) {
                  return _vm.$emit("back")
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    left: "",
                    small: "",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-arrow-left")]
              ),
              _vm._v("Back to apps ")
            ],
            1
          )
        ],
        1
      ),
      _vm.loading && !_vm.detail
        ? _c(
            "div",
            {
              staticClass: "py-8 text-center",
              attrs: {
                role: "status"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: "32",
                  width: "3"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "kvm-sr-only"
                },
                [_vm._v("Loading " + _vm._s(_vm.name) + "…")]
              )
            ],
            1
          )
        : _vm.error && !_vm.detail
        ? _c(
            "v-alert",
            {
              attrs: {
                type: "error",
                border: "left",
                dense: "",
                role: "alert"
              }
            },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm.detail
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap align-center mb-4"
              },
              [
                _c("kvm-logo", {
                  staticClass: "mr-3",
                  attrs: {
                    item: _vm.app || {
                      slug: _vm.name
                    },
                    size: 40,
                    "default-icon": "mdi-docker"
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "mr-auto"
                  },
                  [
                    _c(
                      "h3",
                      {
                        staticClass: "body-1 font-weight-medium mb-0"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.app && _vm.app.name ? _vm.app.name : _vm.name
                          )
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "kvm-help text-caption"
                      },
                      [
                        _vm.app && _vm.app.name
                          ? [_vm._v("App “" + _vm._s(_vm.name) + "” · ")]
                          : _vm._e(),
                        _vm.busyLabel
                          ? _c(
                              "span",
                              {
                                staticClass: "kvm-dk-busy"
                              },
                              [
                                _c("v-progress-circular", {
                                  staticClass: "mr-1",
                                  attrs: {
                                    indeterminate: "",
                                    size: "12",
                                    width: "2",
                                    color: "primary",
                                    "aria-hidden": "true"
                                  }
                                }),
                                _vm._v(_vm._s(_vm.busyLabel) + " ")
                              ],
                              1
                            )
                          : [_vm._v(_vm._s(_vm.statusText))]
                      ],
                      2
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "text-no-wrap mt-1"
                  },
                  [
                    _vm.openUrl
                      ? _c(
                          "gg-btn",
                          {
                            staticClass: "kvm-dk-primary mr-2",
                            attrs: {
                              small: "",
                              tile: "",
                              color: "primary",
                              href: _vm.openUrl,
                              target: "_blank",
                              rel: "noopener"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  left: "",
                                  small: "",
                                  "aria-hidden": "true"
                                }
                              },
                              [_vm._v("mdi-open-in-new")]
                            ),
                            _vm._v("Open ")
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "gg-btn",
                      {
                        staticClass: "mr-1",
                        attrs: {
                          small: "",
                          tile: "",
                          outlined: "",
                          color: "primary",
                          disabled: !!_vm.busyLabel
                        },
                        on: {
                          click: function click($event) {
                            return _vm.$emit("action", "restart")
                          }
                        }
                      },
                      [_vm._v("Restart")]
                    ),
                    _vm.running
                      ? _c(
                          "gg-btn",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              small: "",
                              tile: "",
                              outlined: "",
                              color: "primary",
                              disabled: !!_vm.busyLabel
                            },
                            on: {
                              click: function click($event) {
                                return _vm.$emit("action", "stop")
                              }
                            }
                          },
                          [_vm._v("Stop")]
                        )
                      : _c(
                          "gg-btn",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              small: "",
                              tile: "",
                              outlined: "",
                              color: "primary",
                              disabled: !!_vm.busyLabel
                            },
                            on: {
                              click: function click($event) {
                                return _vm.$emit("action", "start")
                              }
                            }
                          },
                          [_vm._v("Start")]
                        ),
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "offset-y": "",
                          left: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function fn(_ref) {
                              var on = _ref.on,
                                attrs = _ref.attrs
                              return [
                                _c(
                                  "gg-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          "aria-label": "More actions",
                                          disabled: !!_vm.busyLabel
                                        }
                                      },
                                      "gg-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: ""
                                        }
                                      },
                                      [_vm._v("mdi-dots-vertical")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "v-list",
                          {
                            attrs: {
                              dense: ""
                            }
                          },
                          [
                            _vm.managed
                              ? _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.$emit("action", "up")
                                      }
                                    }
                                  },
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v("Redeploy")
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.managed
                              ? _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.$emit("action", "update")
                                      }
                                    }
                                  },
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v("Update to the newest build")
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.$emit("edit")
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.managed
                                        ? "Edit compose file"
                                        : "View details"
                                    )
                                  )
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.$emit("action", "down")
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Take down (remove containers)")
                                ])
                              ],
                              1
                            ),
                            _vm.managed
                              ? _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.$emit("remove")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      {
                                        staticClass: "error--text"
                                      },
                                      [_vm._v("Delete app…")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm.pairing
              ? _c(
                  "section",
                  {
                    staticClass: "kvm-dk-section",
                    attrs: {
                      "aria-labelledby": "kvm-dk-m-pair"
                    }
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "subtitle-2 mb-1",
                        attrs: {
                          id: "kvm-dk-m-pair"
                        }
                      },
                      [_vm._v("Browser access")]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "mb-2"
                      },
                      [
                        _vm._v(
                          " Each new browser you sign in with has to be approved once. Open the app, sign in, and when it asks for approval, approve it here. "
                        )
                      ]
                    ),
                    _c(
                      "gg-btn",
                      {
                        staticClass: "kvm-dk-primary",
                        attrs: {
                          small: "",
                          tile: "",
                          color: "primary"
                        },
                        on: {
                          click: function click($event) {
                            _vm.pairingOpen = true
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: "",
                              "aria-hidden": "true"
                            }
                          },
                          [_vm._v("mdi-check-decagram")]
                        ),
                        _vm._v("Approve a browser ")
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "section",
              {
                staticClass: "kvm-dk-section",
                attrs: {
                  "aria-labelledby": "kvm-dk-m-where"
                }
              },
              [
                _c(
                  "h4",
                  {
                    staticClass: "subtitle-2 mb-1",
                    attrs: {
                      id: "kvm-dk-m-where"
                    }
                  },
                  [_vm._v("Address")]
                ),
                _vm.detail.routes.length || (_vm.app && _vm.app.url)
                  ? _c(
                      "ul",
                      {
                        staticClass: "kvm-dk-list"
                      },
                      [
                        _vm._l(_vm.detail.routes, function(r) {
                          return _c(
                            "li",
                            {
                              key: r.hostname + r.path
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "kvm-dk-link",
                                  attrs: {
                                    href: _vm.routeUrl(r),
                                    target: "_blank",
                                    rel: "noopener"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.routeUrl(r)))]
                              )
                            ]
                          )
                        }),
                        !_vm.detail.routes.length && _vm.app && _vm.app.url
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "kvm-dk-link",
                                  attrs: {
                                    href: _vm.app.url,
                                    target: "_blank",
                                    rel: "noopener"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.app.url))]
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  : _c(
                      "p",
                      {
                        staticClass: "kvm-help mb-0"
                      },
                      [
                        _vm._v(
                          "Not published at a domain. Add one in the Domains tab."
                        )
                      ]
                    ),
                _vm.detail.published_ports.length
                  ? _c(
                      "p",
                      {
                        staticClass: "kvm-help text-caption mb-0 mt-1"
                      },
                      [
                        _vm._v(
                          " Ports on this server: " +
                            _vm._s(_vm.detail.published_ports.join(", ")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _c(
              "section",
              {
                staticClass: "kvm-dk-section",
                attrs: {
                  "aria-labelledby": "kvm-dk-m-ver"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-wrap align-center mb-1"
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "subtitle-2 mb-0 mr-auto",
                        attrs: {
                          id: "kvm-dk-m-ver"
                        }
                      },
                      [_vm._v("Version")]
                    ),
                    _vm.updates.length
                      ? _c(
                          "gg-btn",
                          {
                            staticClass: "kvm-dk-primary mr-2",
                            attrs: {
                              small: "",
                              tile: "",
                              color: "primary",
                              disabled: !!_vm.busyLabel
                            },
                            on: {
                              click: function click($event) {
                                return _vm.$emit("action", "update")
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  left: "",
                                  small: "",
                                  "aria-hidden": "true"
                                }
                              },
                              [_vm._v("mdi-update")]
                            ),
                            _vm._v("Update now ")
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          small: "",
                          tile: "",
                          outlined: "",
                          color: "primary",
                          loading: _vm.checking,
                          disabled: !!_vm.busyLabel || !_vm.versions.length
                        },
                        on: {
                          click: _vm.checkUpdates
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: "",
                              "aria-hidden": "true"
                            }
                          },
                          [_vm._v("mdi-refresh")]
                        ),
                        _vm._v("Check for updates ")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.versionsError
                  ? _c(
                      "p",
                      {
                        staticClass: "kvm-help mb-0"
                      },
                      [_vm._v(_vm._s(_vm.versionsError))]
                    )
                  : _vm._e(),
                _vm._l(_vm.versions, function(v) {
                  return _c(
                    "div",
                    {
                      key: v.image,
                      staticClass: "kvm-dk-ver"
                    },
                    [
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "font-weight-medium"
                          },
                          [_vm._v(_vm._s(v.services.join(", ")))]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "kvm-help text-caption kvm-dk-mono ml-1"
                          },
                          [_vm._v(_vm._s(v.image))]
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "text-caption"
                        },
                        [
                          _vm._v(" Installed: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.buildText(v.installed)))
                          ]),
                          _vm.checked
                            ? [
                                _vm._v(" · "),
                                v.error
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "kvm-help"
                                      },
                                      [_vm._v(_vm._s(v.error))]
                                    )
                                  : v.update_available
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "kvm-dk-new"
                                      },
                                      [
                                        _vm._v("Update available: "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.buildText(v.latest))
                                          )
                                        ])
                                      ]
                                    )
                                  : v.update_available === false
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "kvm-dk-ok"
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              color: "success",
                                              "aria-hidden": "true"
                                            }
                                          },
                                          [_vm._v("mdi-check-circle")]
                                        ),
                                        _vm._v(" Up to date ")
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                }),
                _vm.versions.length
                  ? _c(
                      "p",
                      {
                        staticClass: "kvm-help text-caption mb-0 mt-1"
                      },
                      [
                        _vm._v(
                          " Updates install the newest build of each image's tag (" +
                            _vm._s(_vm.tagsText) +
                            ") and restart the app; your data is kept. Moving to a new major version means changing the tag in the compose file. "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            ),
            _vm.app && _vm.app.credentials.length
              ? _c(
                  "section",
                  {
                    staticClass: "kvm-dk-section",
                    attrs: {
                      "aria-labelledby": "kvm-dk-m-creds"
                    }
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "subtitle-2 mb-1",
                        attrs: {
                          id: "kvm-dk-m-creds"
                        }
                      },
                      [_vm._v("Sign-in details")]
                    ),
                    _vm._l(_vm.app.credentials, function(c) {
                      return _c(
                        "div",
                        {
                          key: c.label,
                          staticClass: "d-flex align-center mb-1"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "kvm-help text-caption mr-2",
                              staticStyle: {
                                "min-width": "140px"
                              }
                            },
                            [_vm._v(_vm._s(c.label))]
                          ),
                          _c("kvm-copyable", {
                            attrs: {
                              value: c.value,
                              display: _vm.reveal[c.label]
                                ? c.value
                                : "••••••••••••"
                            }
                          }),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "ml-1",
                              attrs: {
                                icon: "",
                                "x-small": "",
                                "aria-label":
                                  (_vm.reveal[c.label] ? "Hide " : "Show ") +
                                  c.label
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.$set(
                                    _vm.reveal,
                                    c.label,
                                    !_vm.reveal[c.label]
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    "x-small": ""
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.reveal[c.label]
                                        ? "mdi-eye-off"
                                        : "mdi-eye"
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    _c(
                      "p",
                      {
                        staticClass: "kvm-help text-caption mb-0 mt-1"
                      },
                      [
                        _vm._v(
                          "Keep these private. They're stored only on your server, with the app."
                        )
                      ]
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm.notesHtml
              ? _c(
                  "section",
                  {
                    staticClass: "kvm-dk-section",
                    attrs: {
                      "aria-labelledby": "kvm-dk-m-notes"
                    }
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "subtitle-2 mb-1",
                        attrs: {
                          id: "kvm-dk-m-notes"
                        }
                      },
                      [_vm._v("Getting started")]
                    ),
                    _c("div", {
                      staticClass: "kvm-dk-md",
                      domProps: {
                        innerHTML: _vm._s(_vm.notesHtml)
                      }
                    })
                  ]
                )
              : _vm._e(),
            !_vm.app
              ? _c(
                  "p",
                  {
                    staticClass: "kvm-help text-caption"
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.managed
                            ? "This app was installed from a compose file (or before app details were saved), so there are no setup notes for it."
                            : "This app was created outside this panel."
                        ) +
                        " "
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "section",
              {
                staticClass: "kvm-dk-section",
                attrs: {
                  "aria-labelledby": "kvm-dk-m-parts"
                }
              },
              [
                _c(
                  "h4",
                  {
                    staticClass: "subtitle-2 mb-1",
                    attrs: {
                      id: "kvm-dk-m-parts"
                    }
                  },
                  [_vm._v("Containers")]
                ),
                _vm.detail.containers.length
                  ? _c(
                      "v-simple-table",
                      {
                        staticClass: "kvm-dk-table",
                        attrs: {
                          dense: ""
                        }
                      },
                      [
                        _c(
                          "caption",
                          {
                            staticClass: "kvm-sr-only"
                          },
                          [_vm._v("Containers of " + _vm._s(_vm.name))]
                        ),
                        _c(
                          "tbody",
                          _vm._l(_vm.detail.containers, function(c) {
                            return _c(
                              "tr",
                              {
                                key: c.name
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "font-weight-medium"
                                  },
                                  [_vm._v(_vm._s(c.service))]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass: "kvm-dk-mono"
                                  },
                                  [_vm._v(_vm._s(c.image))]
                                ),
                                _c("td", [_vm._v(_vm._s(c.status))])
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  : _c(
                      "p",
                      {
                        staticClass: "kvm-help mb-0"
                      },
                      [
                        _vm._v(
                          "No containers right now. Use Redeploy to start it."
                        )
                      ]
                    ),
                _vm.detail.volumes.length
                  ? _c(
                      "p",
                      {
                        staticClass: "kvm-help text-caption mb-0 mt-2"
                      },
                      [
                        _vm._v(" Data volumes: "),
                        _c(
                          "span",
                          {
                            staticClass: "kvm-dk-mono"
                          },
                          [_vm._v(_vm._s(_vm.detail.volumes.join(", ")))]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.pairing
        ? _c("kvm-docker-pairing", {
            attrs: {
              "service-id": _vm.serviceId,
              stack: _vm.name,
              "app-name": _vm.app && _vm.app.name ? _vm.app.name : _vm.name
            },
            model: {
              value: _vm.pairingOpen,
              callback: function callback($$v) {
                _vm.pairingOpen = $$v
              },
              expression: "pairingOpen"
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }